import { useEffect } from 'react';
import { setDocumentTitleForPrintPreview } from '../../../utils/print';
import { DEFAULT_BRAND_KEY, type BrandKey } from '../../../config/brands';
import { BRAND_PROFILES } from '../../../config/brandProfiles';
import type { StatementModel, WorkbenchState } from '../../utils/useStatementModel';
import { monthLabel } from '../../utils/useStatementModel';
import { PrintableStatement } from './PrintableStatement';

interface StatementPrintPreviewProps {
  model: StatementModel;
  state: WorkbenchState;
  month: string;
  brand?: BrandKey;
  onBack: () => void;
}

/**
 * Full-page print preview of the composed statement — same pattern as
 * WaiverPrintPreview / PrintableInvoice: rendered instead of the AdminLayout
 * tree so the browser's print output is exactly this page.
 */
export function StatementPrintPreview({ model, state, month, brand = DEFAULT_BRAND_KEY, onBack }: StatementPrintPreviewProps) {
  useEffect(() => {
    // The saved PDF's default file name. The default brand keeps the name it always had.
    const who = brand === DEFAULT_BRAND_KEY ? '' : `${BRAND_PROFILES[brand].shortName} - `;
    const cleanup = setDocumentTitleForPrintPreview(`Revenue Share - ${who}${monthLabel(month)}`);
    return cleanup;
  }, [month, brand]);

  return (
    <div>
      <div className="fixed top-4 right-4 z-50 space-x-4 print:hidden">
        <button
          onClick={() => window.print()}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Print / Save PDF
        </button>
        <button onClick={onBack} className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700">
          Back
        </button>
      </div>

      <PrintableStatement model={model} state={state} month={month} brand={brand} />
    </div>
  );
}
